<!--
 * @Author: 陈小英 13880788935@163.com
 * @Date: 2023-12-23 14:57:12
 * @LastEditors: 陈小英 13880788935@163.com
 * @LastEditTime: 2024-04-01 10:40:17
 * @FilePath: \operation-center\src\components\GlobalHeader\RightContent.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%A
-->
<template>
  <div :class="wrpCls">
    <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown'

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action',
    },
    isMobile: {
      type: Boolean,
      default: () => false,
    },
    topMenu: {
      type: Boolean,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showMenu: true,
      currentUser: {},
    }
  },
  computed: {
    wrpCls() {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${this.isMobile || !this.topMenu ? 'light' : this.theme}`]: true,
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.currentUser = JSON.parse(localStorage.getItem('user'))
      // 异常上报sdk， 设置用户名
      if (this.currentUser) {
        if (window?.botReport) {
          window.botReport.setUserName(`${this.currentUser.name} (${this.currentUser.job_number})`)
        }
      }
    }, 1)
  },
}
</script>
